import { useHistory } from "react-router-dom";
import { withProcedureWraper } from "../../../../..";
import { useAFLColumns, useAFLRequests } from "../../../hooks";
import { Routes } from "../../../../../../../AppRoutes";
import { Box, Icon, Table, UserManual } from "../../../../../../../components";
import CreateRequestButton from "../../../../../components/CreateRequestButton";
import { AFLType } from "../../../models";

export const SickLeaveList = withProcedureWraper(() => {
  const history = useHistory();

  const { columns, columns2 } = useAFLColumns();
  const { isLoading, myRequests, myRequestsNeedApproval, completedMyRequests } = useAFLRequests({
    department: ["DAD"],
    aflType: AFLType.SickLeaveApplication,
  });

  const redirectToDetailPage = (requestId: string) => {
    history.push(`${Routes.sickLeaveDADPage.path}/${requestId}`);
  };

  const redirectToCreatePage = () => {
    history.push(Routes.createSickLeaveDADPage.path);
  };

  return (
    <div className="pd15">
      <UserManual
        icon={<Icon.DocumentWrite />}
        title="ĐƠN XIN NGHỈ ỐM/NUÔI CON ỐM"
        guideLink="https://drive.google.com/file/d/10sDz4KqrfULWxYOgz4sU8STxDaL3vrpn/view"
      />
      <Box title="Yêu cầu đã duyệt" titleRight={<CreateRequestButton onClick={redirectToCreatePage} />}>
        <Table
          rowKey="id"
          loading={isLoading}
          columns={columns2}
          dataSource={completedMyRequests}
          onRow={(record: any) => ({
            onClick: () => redirectToDetailPage(record.id),
            style: { cursor: "pointer" },
          })}
          scroll={{ x: 1500 }}
        />
      </Box>
      <Box title="Yêu cầu cần duyệt">
        <Table
          rowKey="id"
          loading={isLoading}
          columns={columns2}
          dataSource={myRequestsNeedApproval}
          onRow={(record: any) => ({
            onClick: () => redirectToDetailPage(record.id),
            style: { cursor: "pointer" },
          })}
          scroll={{ x: 1500 }}
        />
      </Box>
      <Box title="Tất cả yêu cầu">
        <Table
          rowKey="id"
          loading={isLoading}
          columns={columns}
          dataSource={myRequests}
          onRow={(record: any) => ({
            onClick: () => redirectToDetailPage(record.id),
            style: { cursor: "pointer" },
          })}
          scroll={{ x: 1500 }}
        />
      </Box>
    </div>
  );
});
